import React, { FunctionComponent } from 'react';
import { SvgCog, SvgX } from '@grubhubprod/gh-cookbook-react';
import { Environment } from 'src/environment';
import { withInjectedProps } from 'src/shared/di';
import { TYPES } from 'src/shared/di/types';
import { RouteComponentProps, withRouter } from 'src/shared/router';
import './DevBanner.scss';

export interface DevBannerProps extends RouteComponentProps {
  appConfig: AppConfig;
}

export const DevBannerUnconnected: FunctionComponent<DevBannerProps> = ({
  appConfig,
  history,
}) => {
  const { environment, platform } = appConfig;

  return environment !== Environment.PROD ? (
    <div id="dev-banner">
      <button id="dev-settings" onClick={handleNavigation}>
        <SvgCog width={16} height={16} />
        <span>Dev Settings | Platform: {platform}</span>
      </button>
      <button onClick={hideDevBanner}>
        <SvgX width={16} height={16} />
      </button>
    </div>
  ) : null;

  function handleNavigation(): void {
    history.push('/settings');
  }

  function hideDevBanner(): void {
    const devBanner = document.getElementById('dev-banner');

    if (devBanner) {
      devBanner.style.display = 'none';
    }
  }
};

DevBannerUnconnected.displayName = 'DevBanner';

export const DevBanner = withRouter(
  withInjectedProps(DevBannerUnconnected, {
    appConfig: TYPES.AppConfig,
  }),
);
